<script>
import Input from '@components/Input'
import Button from '@components/Button'
import Dialog from '@components/Dialog'
import Loading from '@components/Loading'
import { mask } from 'vue-the-mask'
import { mapActions } from 'vuex'

export default {
  name: 'PageContato',
  directives: { mask },
  components: { Input, Button, Dialog, Loading },
  data () {
    return {
      nome: '',
      email: '',
      telefone: '',
      mensagem: '',
      errors: {
        nome: '',
        email: '',
        telefone: '',
        mensagem: ''
      },
      loading: false
    }
  },
  computed: {
    scale () {
      return {
        xs: 0.5,
        sm: 0.6,
        md: 0.8,
        lg: 1,
        xl: 1
      }[this.rl.breakpoint]
    },
    styles () {
      return {
        contato: {
          '--scale': this.scale,
          '--margin': this.rl.margin
        }
      }
    }
  },
  methods: {
    resetarInputs () {
      ['nome', 'telefone', 'email', 'mensagem'].forEach(key => {
        this.$data[key] = ''
      })
    },
    validar () {
      const validations = {
        nome: [v => !v && this.$wl.strings['erro-nome-obrigatorio']],
        telefone: [v => !v && this.$wl.strings['erro-telefone-obrigatorio'], v => !/^\(\d{2}\)\s\d{4,5}-\d{4}$/.test(v) && this.$wl.strings['erro-telefone-invalido']],
        email: [v => !v && this.$wl.strings['erro-email-obrigatorio'], v => !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) && this.$wl.strings['erro-email-invalido']],
        mensagem: [v => !v && this.$wl.strings['erro-mensagem-obrigatoria']]
      }
      return ['nome', 'email', 'telefone', 'mensagem'].every(key => {
        const element = document.getElementById(`input-${key}`)
        const input = element.getElementsByClassName('input')[0]
        const value = input.value
        return validations[key].every(validation => {
          const error = validation(value)
          this.$set(this.errors, key, error || '')
          input.focus()
          return !error
        })
      })
    },
    resetarErro (key) {
      this.$set(this.errors, key, '')
    },
    resetarTodosOsErros () {
      ['nome', 'email', 'telefone', 'mensagem'].forEach(this.resetarErro)
    },
    enviar () {
      const t = setTimeout(() => {
        this.loading = true
      }, 250)
      this.resetarTodosOsErros()
      if (this.validar()) {
        const data = {
          nome: this.none,
          email: this.email,
          telefone: this.telefone,
          mensagem: this.mensagem
        }
        this.postContato(data).then(() => {
          this.$refs.dialog.open()
          this.resetarInputs()
        }).catch(error => {
          console.log(error)
          this.$refs.errorDialog.open()
        }).finally(() => {
          clearTimeout(t)
          this.loading = false
        })
      } else {
        clearTimeout(t)
        this.loading = false
      }
    },
    ...mapActions(['postContato'])
  }
}
</script>

<template>
  <div
    class="page-contato"
    :style="styles.contato"
  >
    <div class="input-container">
      <Input
        id="input-nome"
        v-model="nome"
        :label="$wl.strings['label-nome']"
        :error="errors.nome"
        :scale="scale"
        @input="resetarErro('nome')"
      />
      <div class="input-row">
        <div>
          <Input
            id="input-email"
            v-model="email"
            :label="$wl.strings['label-email']"
            type="email"
            :error="errors.email"
            :scale="scale"
            @input="resetarErro('email')"
          />
        </div>
        <div>
          <Input
            id="input-telefone"
            v-model="telefone"
            v-mask="['(##) ####-####', '(##) #####-####']"
            :label="$wl.strings['label-telefone']"
            type="tel"
            :error="errors.telefone"
            :scale="scale"
            @input="resetarErro('telefone')"
          />
        </div>
      </div>
    </div>
    <Input
      id="input-mensagem"
      v-model="mensagem"
      :area="true"
      :label="$wl.strings['label-mensagem-contato']"
      :error="errors.mensagem"
      :scale="scale"
      @input="resetarErro('mensagem')"
    />
    <div class="btn-enviar-container">
      <Button
        :color="wl.colors.secondary"
        :text-color="wl.colors.on.secondary"
        :text="wl.strings['btn-enviar']"
        size="lg"
        :scale="scale"
        @click="enviar"
      />
    </div>
    <Dialog
      ref="dialog"
      :fullscreen="false"
    >
      <template v-slot:title>
        <span v-html="$wl.strings['dialog-contato-success-title']" />
      </template>
      <template v-slot:text>
        <span v-html="$wl.strings['dialog-contato-success-message']" />
      </template>
    </Dialog>
    <Dialog ref="errorDialog">
      <template v-slot:title>
        <span v-html="$wl.strings['dialog-error-title']" />
      </template>
      <template v-slot:text>
        <span v-html="$wl.strings['dialog-contato-error-message']" />
      </template>
    </Dialog>
    <Loading
      :visible="loading"
      background-color="rgba(0, 0, 0, 0.5)"
      spinner-color="white"
    />
  </div>
</template>

<style lang="scss" scoped>
.page-contato {
  color: var(--on-background);
  padding: 0 var(--margin);
  .input-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    > div {
      &:nth-child(1) {
        padding-right: calc(15px * var(--scale));
        width: calc(60% - 15px * var(--scale));
      }
      &:nth-child(2) {
        width: 40%;
      }
    }
    @media (max-width: 599px) {
      > div {
        &:nth-child(1) {
          padding-right: 0;
          width: 100%;
        }
        &:nth-child(2) {
          width: 100%;
        }
      }
    }
  }
  .btn-enviar-container {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 25px;
  }
}
</style>
